import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import Inr from '@/components/Inr/index.vue';
import Thumb from '@/components/Thumb/index.vue';
import { AdminModule } from '@/store/modules/admin';
import { reviseOrder } from '@/api/order';
import { isSuperAdmin } from '@/common';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.reviseOrderFlag = false;
  }
  _isSuperAdmin() {
    return isSuperAdmin();
  }
  isOrderManager() {
    return ['Order Manager'].includes(AdminModule.roles.toString());
  }
  async _reviseOrder(orderId = 0) {
    try {
      this.reviseOrderFlag = true;
      const confirm = await this.$confirm('Are you sure to recalculate this order?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonClass: 'el-button--success',
        cancelButtonClass: 'el-button--danger',
        type: 'warning'
      });
      // check if confirm
      if (confirm === 'confirm') {
        const data = await reviseOrder({
          id: orderId,
          saveDiscounts: true,
          skipReturn: true
        });
        this.$message({
          type: 'success',
          message: 'Order recalculated successfully'
        });
        // refresh the order
        this.$emit('refresh');
      }
    } catch (error) {
      this.$message({
        type: 'error',
        message: error.toString()
      });
    } finally {
      this.reviseOrderFlag = false;
    }
  }
};
__decorate([Prop({
  default: {}
})], default_1.prototype, "data", void 0);
default_1 = __decorate([Component({
  name: 'OrderInfoTab',
  components: {
    Inr,
    Thumb
  }
})], default_1);
export default default_1;